var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33332 33.2493C5.46249 33.2493 4.71727 32.9395 4.09766 32.3199C3.47805 31.7003 3.16771 30.9546 3.16666 30.0827V12.666C3.16666 11.7952 3.47699 11.05 4.09766 10.4303C4.71832 9.81074 5.46355 9.5004 6.33332 9.49935H12.6667V6.33268C12.6667 5.46185 12.977 4.71663 13.5977 4.09702C14.2183 3.4774 14.9635 3.16707 15.8333 3.16602H22.1667C23.0375 3.16602 23.7832 3.47635 24.4039 4.09702C25.0246 4.71768 25.3344 5.4629 25.3333 6.33268V9.49935H31.6667C32.5375 9.49935 33.2832 9.80968 33.9039 10.4303C34.5246 11.051 34.8344 11.7962 34.8333 12.666V30.0827C34.8333 30.9535 34.5235 31.6993 33.9039 32.3199C33.2843 32.9406 32.5385 33.2504 31.6667 33.2493H6.33332ZM6.33332 30.0827H31.6667V12.666H6.33332V30.0827ZM15.8333 9.49935H22.1667V6.33268H15.8333V9.49935Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkIcon);
export default __webpack_public_path__ + "static/media/work-icon.04ee4ff0a9deecbca2b1ff410c1d70ec.svg";
export { ForwardRef as ReactComponent };